import styled from "@emotion/styled";

export const FlyerDetailPageFormPositionControls = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  & button {
    display: block;
    margin: 16px 0 0 0;
    max-width: 100px;
  }
`;
